"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimClosureReason = exports.ClaimCategory = exports.ClaimType = void 0;
var ClaimType;
(function (ClaimType) {
    ClaimType["CLAIM"] = "claim";
    ClaimType["DISSATISFACTION"] = "dissatisfaction";
    ClaimType["GUARANTEED_RETURN"] = "guaranteed_return";
    ClaimType["NON_COMPLIANCE"] = "non_compliance";
    ClaimType["OTHER"] = "other";
})(ClaimType = exports.ClaimType || (exports.ClaimType = {}));
var ClaimCategory;
(function (ClaimCategory) {
    ClaimCategory["WEBSITE_WORKFLOW"] = "website_workflow";
    ClaimCategory["INTERVENTION_FOLLOWUP"] = "intervention_followup";
    ClaimCategory["PRICE"] = "price";
    ClaimCategory["SERVICE_QUALITY"] = "service_quality";
    ClaimCategory["SHOWING_QUALITY"] = "showing_quality";
    ClaimCategory["PAYMENT_ISSUES"] = "payment_issues";
    ClaimCategory["CANCELLATION"] = "cancellation";
    ClaimCategory["INTERVENTION_DELAY"] = "intervention_delay";
    ClaimCategory["DELAY"] = "delay";
    ClaimCategory["NO_CALL_15MIN"] = "no_call_15min";
    ClaimCategory["NO_CONSTRUCTION_SITE_CLEANUP"] = "no_construction_site_cleanup";
    ClaimCategory["TRADER_BEHAVIOR"] = "trader_behavior";
    ClaimCategory["GUARANTEED_RETURN"] = "guaranteed_return_cat";
})(ClaimCategory = exports.ClaimCategory || (exports.ClaimCategory = {}));
var ClaimClosureReason;
(function (ClaimClosureReason) {
    ClaimClosureReason["PARTIAL_REFUND"] = "partial_refund";
    ClaimClosureReason["TOTAL_REFUND"] = "total_refund";
    ClaimClosureReason["TRADER_RETURN"] = "trader_return";
    ClaimClosureReason["SEND_OTHER_TRADER"] = "send_other_trader";
    ClaimClosureReason["PROMOTION_COUPON"] = "promotion_coupon";
    ClaimClosureReason["MODERATION"] = "moderation";
    ClaimClosureReason["REFUSAL"] = "refusal";
})(ClaimClosureReason = exports.ClaimClosureReason || (exports.ClaimClosureReason = {}));
//# sourceMappingURL=claim.js.map